var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-23964699"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "pl-4 flex items-center"
};
var _hoisted_2 = ["placeholder"];
var _hoisted_3 = {
    key: 1,
    class: "e-select__label pl-4 truncate flex items-center"
};
var _hoisted_4 = {
    key: 0,
    class: "e-select__placeholder"
};
var _hoisted_5 = {
    key: 1,
    class: "max-w-full"
};
var _hoisted_6 = {
    key: 0,
    class: "flex max-w-full"
};
var _hoisted_7 = ["placeholder"];
var _hoisted_8 = {
    key: 1,
    class: "flex max-w-full flex-wrap py-2"
};
var _hoisted_9 = ["placeholder"];
var _hoisted_10 = {
    key: 2,
    class: "whitespace-nowrap truncate flex items-center space-x-2"
};
var _hoisted_11 = { class: "shrink-0 px-2" };
var _hoisted_12 = ["onClick"];
var _hoisted_13 = { class: "max-w-[300px]" };
var _hoisted_14 = { class: "items-center flex" };
var _hoisted_15 = {
    key: 0,
    class: "mr-4 flex items-center"
};
var _hoisted_16 = { class: "w-fit" };
var _hoisted_17 = {
    key: 1,
    class: "text-gray-400 text-center px-2 py-2"
};
var _hoisted_18 = { class: "e-select__outer-tag" };
var _hoisted_19 = { class: "grow" };
var _hoisted_20 = {
    key: 0,
    class: "text-gray-400"
};
import { computed, nextTick, onBeforeMount, ref, watch } from 'vue';
import ETag from '@common/ui/ETag.vue';
import { distinctArray } from '@common/utils/Array/Array';
import EMenuItem from '@common/ui/EMenu/EMenuItem.vue';
import { fillObject } from '@common/utils/Object/Object';
import PlanContent from '@school/components/PlanContent.vue';
import EIcon from '@common/ui/EIcon.vue';
import EMenu from '@common/ui/EMenu/EMenu.vue';
import EDropdown from '@common/ui/EDropdown/EDropdown.vue';
import CEmployeeAvatar from '@common/components/CEmployeeAvatar.vue';
import EAvatar from '@common/ui/EAvatar/EAvatar.vue';
import ETooltip from '@common/ui/ETooltip.vue';
import { useI18n } from 'vue-i18n';
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false,
}, { __name: 'ESelect', props: /*#__PURE__*/ _mergeModels({
        options: {},
        size: { default: 'medium' },
        placeholder: {},
        multiple: { type: Boolean },
        filterable: { type: Boolean },
        clipTags: { type: Boolean },
        outerTags: { type: Boolean },
        grouped: { type: [Boolean, Object] },
        disabled: { type: Boolean },
        noOptionsText: {},
        nothingFoundText: {},
        isErrored: { type: Boolean },
        tagsClass: {},
        header: {},
        theme: { default: 'white' },
        hideCurrent: { type: Boolean },
        dynamicOverlayWidth: { type: Boolean, default: false },
        emptyContent: { type: Boolean },
        fullwidth: { type: Boolean },
        appendToBody: { type: Boolean, default: true },
        tagsWrap: { type: Boolean },
        useCustomRender: { type: Boolean }
    }, {
        "modelValue": {},
        "modelModifiers": {},
        "visible": { default: false },
        "visibleModifiers": {},
    }), emits: /*#__PURE__*/ _mergeModels(["change"], ["update:modelValue", "update:visible"]), setup: function (__props, _a) {
        var _this = this;
        var __expose = _a.expose, __emit = _a.emit;
        var t = useI18n().t;
        var props = __props;
        var placeholder = props.placeholder || t('select.placeholder');
        var noOptionsText = props.noOptionsText || t('select.noOptionsText');
        var nothingFoundText = props.nothingFoundText || t('select.nothingFoundText');
        var modelValue = _useModel(__props, "modelValue");
        var emit = __emit;
        var searchRef = ref();
        var selectRef = ref();
        var searchInTagsRef = ref();
        var searchInClippedTagsRef = ref();
        var optionsRef = ref();
        var optionsVisible = _useModel(__props, 'visible');
        var search = ref('');
        var searchVisible = ref(false);
        var localModelValue = ref(null);
        var overlayWidth = ref('auto');
        watch(modelValue, function (val) {
            if (val === localModelValue.value) {
                return;
            }
            localModelValue.value = val;
        });
        var inputSize = computed(function () {
            return {
                'mini': 'e-select--mini',
                'small': 'e-select--small',
                'medium': 'e-select--medium',
                'large': 'e-select--large',
            }[props.size];
        });
        var themeClass = computed(function () {
            return {
                'white': 'e-select--white',
                'gray': 'e-select--gray',
            }[props.theme];
        });
        // const collapseTagSize = computed(() => {
        //     return ['small', 'mini'].includes(props.size) ? 'mini' : 'small';
        // });
        onBeforeMount(function () {
            var _a;
            // ! TODO связать их
            localModelValue.value = props.multiple ? (_a = modelValue.value) !== null && _a !== void 0 ? _a : [] : modelValue.value;
        });
        // onMounted(() => {
        //     document.addEventListener('click', onGlobalClick);
        // });
        //
        // onBeforeUnmount(() => {
        //     document.removeEventListener('click', onGlobalClick);
        // });
        var sortedOptions = computed(function () {
            var e_1, _a;
            if (!props.grouped) {
                return props.options;
            }
            var grouped = {};
            try {
                for (var _b = __values(props.options), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    if (!grouped[item.group.value]) {
                        grouped[item.group.value] = [];
                    }
                    grouped[item.group.value].push(item);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return Object.values(grouped).flat();
        });
        var filteredOptions = computed(function () {
            var searchBy = function (label) {
                return ('' + label).toLowerCase().trim().includes(search.value.toLowerCase().trim());
            };
            if (!sortedOptions.value) {
                return [];
            }
            return (sortedOptions.value)
                .filter(function (o) {
                var _a;
                return searchBy('' + o.label) ||
                    (((_a = o.group) === null || _a === void 0 ? void 0 : _a.label) ? searchBy('' + o.group.label) : false);
            })
                .filter(function (e) { return props.hideCurrent ? e.value !== localModelValue.value : true; });
            // return (<Option[]>sortedOptions.value)
            //     .filter(o => ('' + o.label).toLowerCase().trim().includes(search.value.toLowerCase().trim()))
            //     .filter(e => props.hideCurrent ? e.value !== localModelValue.value : true)
        });
        var selectedOptions = computed(function () {
            var _a, _b, _c, _d;
            if (props.multiple) {
                return (_b = (_a = props.options) === null || _a === void 0 ? void 0 : _a.filter(function (o) { var _a; return (_a = localModelValue.value) === null || _a === void 0 ? void 0 : _a.includes(o.value); })) !== null && _b !== void 0 ? _b : [];
            }
            return (_d = (_c = props.options) === null || _c === void 0 ? void 0 : _c.find(function (o) { return o.value === localModelValue.value; })) !== null && _d !== void 0 ? _d : null;
        });
        var onOptionClick = function (option) {
            if (props.disabled) {
                return;
            }
            var isSelected = isOptionSelected(option);
            if (isSelected) {
                if (props.multiple) {
                    removeOptionsFromModel([option]);
                }
                else {
                    // modelValue.value = null;
                    closeOptions();
                }
            }
            else {
                if (props.multiple) {
                    // Если в группе должен быть выбран только один пункт,
                    // убираем перед включением нового все элементы старой группы
                    if (groupOptions.value.singleValuePerGroup) {
                        var groupOptions_1 = props.options.filter(function (o) { var _a; return ((_a = o.group) === null || _a === void 0 ? void 0 : _a.value) === option.group.value; });
                        // Удаляем из модели все опции данной группы
                        removeOptionsFromModel(groupOptions_1);
                        // Добавляем в модель изменения
                        addOptionsToModel([option]);
                    }
                    else {
                        addOptionsToModel([option]);
                    }
                }
                else {
                    localModelValue.value = option.value;
                    closeOptions();
                }
            }
            emitChange();
            nextTick(function () {
                focusSearchInput();
            });
        };
        var onGroupClick = function (group) {
            var _a;
            if (!props.multiple || ((_a = props.grouped) === null || _a === void 0 ? void 0 : _a.selectSingleInGroup) || props.disabled) {
                return;
            }
            var groupOptions = props.options.filter(function (o) { var _a; return ((_a = o.group) === null || _a === void 0 ? void 0 : _a.value) === group.value; });
            var isAllGroupOptionsSelected = groupOptions.every(function (o) { return localModelValue.value.includes(o.value); });
            if (isAllGroupOptionsSelected) {
                // Удаляем из модели все опции данной группы
                removeOptionsFromModel(groupOptions);
            }
            else {
                // Добавляем в модель все опции данной группы, map нужен чтобы избежать дублей
                addOptionsToModel(groupOptions);
            }
            emitChange();
            nextTick(function () {
                focusSearchInput();
            });
        };
        var onTagClose = function (option) {
            removeOptionsFromModel([option]);
            emitChange();
        };
        var addOptionsToModel = function (options) {
            if (props.disabled) {
                return;
            }
            if (Array.isArray(localModelValue.value)) {
                var optionsValues = options.map(function (o) { return o.value; });
                localModelValue.value = distinctArray(__spreadArray(__spreadArray([], __read(localModelValue.value), false), __read(optionsValues), false));
            }
        };
        var removeOptionsFromModel = function (options) {
            if (props.disabled) {
                return;
            }
            if (Array.isArray(localModelValue.value)) {
                var optionsValues_1 = options.map(function (o) { return o.value; });
                localModelValue.value = __spreadArray([], __read(localModelValue.value.filter(function (mv) { return !optionsValues_1.includes(mv); })), false);
            }
        };
        var isOptionSelected = function (option) {
            var _a, _b;
            return props.multiple ? (_b = (_a = localModelValue.value) === null || _a === void 0 ? void 0 : _a.includes(option.value)) !== null && _b !== void 0 ? _b : false : localModelValue.value === option.value;
        };
        var toggleOptionsVisible = function () {
            if (optionsVisible.value) {
                openOptions();
            }
            else {
                closeOptions();
            }
        };
        watch(optionsVisible, toggleOptionsVisible);
        var openOptions = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (props.disabled) {
                            return [2 /*return*/];
                        }
                        searchVisible.value = true;
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        focusSearchInput();
                        if (props.dynamicOverlayWidth) {
                            setTimeout(function () {
                                updateOverlayWidth();
                            }, 100);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var closeOptions = function () {
            searchVisible.value = false;
            optionsVisible.value = false;
            search.value = '';
        };
        var onInputFocus = function (e) {
            openOptions();
        };
        var focusSearchInput = function () {
            var _a, _b, _c, _d, _e;
            if (!props.filterable) {
                return;
            }
            if (props.multiple && ((_a = selectedOptions.value) === null || _a === void 0 ? void 0 : _a.length) > 0 && props.clipTags) {
                (_b = searchInClippedTagsRef.value) === null || _b === void 0 ? void 0 : _b.focus();
            }
            else if (props.multiple && ((_c = selectedOptions.value) === null || _c === void 0 ? void 0 : _c.length) > 0 && !props.clipTags) {
                (_d = searchInTagsRef.value) === null || _d === void 0 ? void 0 : _d.focus();
            }
            else {
                (_e = searchRef.value) === null || _e === void 0 ? void 0 : _e.focus();
            }
        };
        var shouldShowGroup = function (option) {
            var _a, _b, _c;
            if (!props.options || !props.grouped) {
                return false;
            }
            var options = filteredOptions.value;
            var currentOptionIndex = (_a = options === null || options === void 0 ? void 0 : options.findIndex(function (o) { return o.value === option.value; })) !== null && _a !== void 0 ? _a : -1;
            var previousOption = currentOptionIndex > 0 ? options[currentOptionIndex - 1] : null;
            return previousOption ? ((_b = previousOption === null || previousOption === void 0 ? void 0 : previousOption.group) === null || _b === void 0 ? void 0 : _b.value) !== ((_c = option === null || option === void 0 ? void 0 : option.group) === null || _c === void 0 ? void 0 : _c.value) : true;
        };
        var groupOptions = computed(function () {
            var options = {
                singleValuePerGroup: false,
            };
            if (typeof props.grouped !== 'boolean') {
                fillObject(options, props.grouped);
            }
            return options;
        });
        var emitChange = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modelValue.value = localModelValue.value;
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        emit('change', localModelValue.value);
                        return [2 /*return*/];
                }
            });
        }); };
        var updateOverlayWidth = function () { return __awaiter(_this, void 0, void 0, function () {
            var menuItems, maxContentWidth, minWidth, padding;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!props.dynamicOverlayWidth || !optionsRef.value) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _b.sent();
                        overlayWidth.value = 'auto';
                        return [4 /*yield*/, nextTick()];
                    case 2:
                        _b.sent();
                        menuItems = optionsRef.value.querySelectorAll('.e-menu-item, .dynamic-scroller .vue-recycle-scroller__item-view');
                        maxContentWidth = 0;
                        menuItems.forEach(function (item) {
                            // Создаем временный элемент для измерения без ограничений ширины
                            var tempElement = item.cloneNode(true);
                            tempElement.style.position = 'absolute';
                            tempElement.style.visibility = 'hidden';
                            tempElement.style.width = 'auto';
                            tempElement.style.whiteSpace = 'nowrap';
                            tempElement.style.top = '-9999px';
                            document.body.appendChild(tempElement);
                            var itemWidth = tempElement.scrollWidth;
                            document.body.removeChild(tempElement);
                            maxContentWidth = Math.max(maxContentWidth, itemWidth);
                        });
                        minWidth = ((_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 200;
                        padding = 32;
                        overlayWidth.value = Math.max(maxContentWidth + padding, minWidth) + 'px';
                        return [2 /*return*/];
                }
            });
        }); };
        watch([filteredOptions, optionsVisible], function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(props.dynamicOverlayWidth && optionsVisible.value)) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        setTimeout(function () {
                            updateOverlayWidth();
                        }, 50);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        __expose({
            toggleOptionsVisible: toggleOptionsVisible
        });
        return function (_ctx, _cache) {
            var _component_e_button = _resolveComponent("e-button");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(EDropdown, {
                    visible: optionsVisible.value,
                    "onUpdate:visible": _cache[6] || (_cache[6] = function ($event) { return ((optionsVisible).value = $event); }),
                    "allowed-placements": ['top', 'bottom'],
                    "append-to-body": _ctx.appendToBody,
                    "follow-reference-width": !_ctx.dynamicOverlayWidth,
                    "offset-amount": 10,
                    trigger: !_ctx.disabled && 'click',
                    class: "w-full",
                    fullwidth: ""
                }, {
                    overlay: _withCtx(function () { return [
                        _createElementVNode("div", {
                            ref_key: "optionsRef",
                            ref: optionsRef,
                            style: _normalizeStyle({ width: _ctx.dynamicOverlayWidth ? overlayWidth.value : 'auto' })
                        }, [
                            _createVNode(EMenu, {
                                label: _ctx.header,
                                "with-scrollbar": _ctx.useCustomRender ? true : false,
                                class: "e-select__options"
                            }, {
                                default: _withCtx(function () { return [
                                    (filteredOptions.value.length > 0)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _renderSlot(_ctx.$slots, "additionalBefore", {
                                                isSelected: isOptionSelected,
                                                onOptionClick: onOptionClick
                                            }),
                                            (!_ctx.useCustomRender)
                                                ? (_openBlock(), _createBlock(_unref(DynamicScroller), {
                                                    key: 0,
                                                    buffer: 600,
                                                    items: filteredOptions.value,
                                                    "min-item-size": 44,
                                                    "page-mode": false,
                                                    style: { maxHeight: 'var(--e-menu-max-h)' },
                                                    class: "overflow-y-auto dynamic-scroller",
                                                    "key-field": "value"
                                                }, {
                                                    default: _withCtx(function (_a) {
                                                        var option = _a.item, index = _a.index, active = _a.active;
                                                        return [
                                                            (_openBlock(), _createBlock(_unref(DynamicScrollerItem), {
                                                                key: option.value,
                                                                active: true,
                                                                index: index,
                                                                item: option,
                                                                class: "w-full"
                                                            }, {
                                                                default: _withCtx(function () { return [
                                                                    (shouldShowGroup(option))
                                                                        ? _renderSlot(_ctx.$slots, "group", {
                                                                            key: 0,
                                                                            group: option.group,
                                                                            onGroupClick: onGroupClick
                                                                        }, function () {
                                                                            var _a;
                                                                            return [
                                                                                _createElementVNode("div", {
                                                                                    class: "px-5 py-2 text-gray-400 text-sm",
                                                                                    onClick: function ($event) { return (onGroupClick(option.group)); }
                                                                                }, _toDisplayString((_a = option.group) === null || _a === void 0 ? void 0 : _a.label), 9, _hoisted_12)
                                                                            ];
                                                                        })
                                                                        : _createCommentVNode("", true),
                                                                    _renderSlot(_ctx.$slots, "option", {
                                                                        isSelected: isOptionSelected,
                                                                        onOptionClick: onOptionClick,
                                                                        option: option
                                                                    }, function () {
                                                                        var _a, _b, _c, _d, _e, _f, _g, _h;
                                                                        return [
                                                                            _createVNode(PlanContent, {
                                                                                disabled: ((_a = option._config) === null || _a === void 0 ? void 0 : _a.planContent) ? (_b = option._config) === null || _b === void 0 ? void 0 : _b.planContent.disabled : false,
                                                                                image: ((_d = (_c = option._config) === null || _c === void 0 ? void 0 : _c.planContent) === null || _d === void 0 ? void 0 : _d.image) || '',
                                                                                plan: ((_f = (_e = option._config) === null || _e === void 0 ? void 0 : _e.planContent) === null || _f === void 0 ? void 0 : _f.plan) || '',
                                                                                title: ((_h = (_g = option._config) === null || _g === void 0 ? void 0 : _g.planContent) === null || _h === void 0 ? void 0 : _h.title) || '',
                                                                                class: "w-full",
                                                                                "block-content": "",
                                                                                onClick: _cache[5] || (_cache[5] = _withModifiers(function () { }, ["stop"]))
                                                                            }, {
                                                                                default: _withCtx(function () { return [
                                                                                    _createVNode(EMenuItem, {
                                                                                        disabled: option.disabled,
                                                                                        "is-selected": isOptionSelected(option),
                                                                                        onSelect: function ($event) { return (onOptionClick(option)); }
                                                                                    }, {
                                                                                        default: _withCtx(function () { return [
                                                                                            _createVNode(ETooltip, {
                                                                                                disabled: !option.tooltip || option.tooltip.length === 0,
                                                                                                trigger: "hover",
                                                                                                unselectable: ""
                                                                                            }, {
                                                                                                tooltip: _withCtx(function () { return [
                                                                                                    _createElementVNode("div", _hoisted_13, _toDisplayString(option.tooltip), 1)
                                                                                                ]; }),
                                                                                                default: _withCtx(function () {
                                                                                                    var _a, _b, _c, _d, _e, _f, _g;
                                                                                                    return [
                                                                                                        _createElementVNode("div", _hoisted_14, [
                                                                                                            (((_a = option._config) === null || _a === void 0 ? void 0 : _a.avatar) || ((_b = option._config) === null || _b === void 0 ? void 0 : _b.icon))
                                                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                                                                                    ((_c = option._config) === null || _c === void 0 ? void 0 : _c.avatar)
                                                                                                                        ? (_openBlock(), _createBlock(EAvatar, {
                                                                                                                            key: 0,
                                                                                                                            name: (_d = option._config) === null || _d === void 0 ? void 0 : _d.avatar.name,
                                                                                                                            src: (_e = option._config) === null || _e === void 0 ? void 0 : _e.avatar.src,
                                                                                                                            class: "!w-7.5 !h-7.5 pointer-events-none"
                                                                                                                        }, null, 8, ["name", "src"]))
                                                                                                                        : _createCommentVNode("", true),
                                                                                                                    ((_f = option._config) === null || _f === void 0 ? void 0 : _f.icon)
                                                                                                                        ? (_openBlock(), _createBlock(EIcon, {
                                                                                                                            key: 1,
                                                                                                                            icon: (_g = option._config) === null || _g === void 0 ? void 0 : _g.icon,
                                                                                                                            class: "h-4 w-4 text-primary"
                                                                                                                        }, null, 8, ["icon"]))
                                                                                                                        : _createCommentVNode("", true)
                                                                                                                ]))
                                                                                                                : _createCommentVNode("", true),
                                                                                                            _createElementVNode("p", _hoisted_16, _toDisplayString(option.label), 1)
                                                                                                        ])
                                                                                                    ];
                                                                                                }),
                                                                                                _: 2
                                                                                            }, 1032, ["disabled"])
                                                                                        ]; }),
                                                                                        _: 2
                                                                                    }, 1032, ["disabled", "is-selected", "onSelect"])
                                                                                ]; }),
                                                                                _: 2
                                                                            }, 1032, ["disabled", "image", "plan", "title"])
                                                                        ];
                                                                    })
                                                                ]; }),
                                                                _: 2
                                                            }, 1032, ["index", "item"]))
                                                        ];
                                                    }),
                                                    _: 3
                                                }, 8, ["items"]))
                                                : _createCommentVNode("", true),
                                            _renderSlot(_ctx.$slots, "additionalAfter", {
                                                isSelected: isOptionSelected,
                                                onOptionClick: onOptionClick
                                            })
                                        ], 64))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(search.value.length > 0 ? _unref(nothingFoundText) : _unref(noOptionsText)), 1))
                                ]; }),
                                _: 3
                            }, 8, ["label", "with-scrollbar"])
                        ], 4)
                    ]; }),
                    arrow: _withCtx(function (_a) {
                        var placement = _a.placement;
                        return [
                            _createElementVNode("div", {
                                class: _normalizeClass([[
                                        placement === 'top' && 'e-select__arrow--reverse'
                                    ], "e-select__arrow"])
                            }, null, 2)
                        ];
                    }),
                    default: _withCtx(function () {
                        var _a, _b, _c;
                        return [
                            _createElementVNode("div", _mergeProps(_ctx.$attrs, {
                                ref_key: "selectRef",
                                ref: selectRef,
                                class: [[
                                        _ctx.isErrored && 'e-select--error',
                                        _ctx.disabled && 'e-select--disabled',
                                        themeClass.value,
                                        inputSize.value
                                    ], "e-select flex items-center"]
                            }), [
                                (_ctx.$slots.prepend)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                        _renderSlot(_ctx.$slots, "prepend", { searchVisible: searchVisible.value })
                                    ]))
                                    : _createCommentVNode("", true),
                                (!_ctx.emptyContent)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (_ctx.filterable && searchVisible.value && !(_ctx.multiple && selectedOptions.value && ((_a = selectedOptions.value) === null || _a === void 0 ? void 0 : _a.length) > 0))
                                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                key: 0,
                                                ref_key: "searchRef",
                                                ref: searchRef,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((search).value = $event); }),
                                                placeholder: _unref(placeholder),
                                                class: "e-select__input",
                                                type: "text",
                                                onFocus: onInputFocus
                                            }, null, 40, _hoisted_2)), [
                                                [_vModelText, search.value]
                                            ])
                                            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                (_ctx.outerTags || !localModelValue.value || (_ctx.multiple && localModelValue.value.length === 0))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(placeholder)), 1))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                        (_ctx.multiple && _ctx.clipTags && selectedOptions.value && selectedOptions.value.length > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                                _createVNode(ETag, {
                                                                    closable: !_ctx.disabled,
                                                                    class: "shrink truncate",
                                                                    size: "small",
                                                                    onClose: _cache[1] || (_cache[1] = function ($event) { return (onTagClose(selectedOptions.value[0])); })
                                                                }, {
                                                                    default: _withCtx(function () { return [
                                                                        _createTextVNode(_toDisplayString(selectedOptions.value[0].label), 1)
                                                                    ]; }),
                                                                    _: 1
                                                                }, 8, ["closable"]),
                                                                (selectedOptions.value.length > 1)
                                                                    ? (_openBlock(), _createBlock(ETag, {
                                                                        key: 0,
                                                                        class: "ml-1",
                                                                        size: "small"
                                                                    }, {
                                                                        default: _withCtx(function () { return [
                                                                            _createTextVNode(" +" + _toDisplayString(selectedOptions.value.length - 1), 1)
                                                                        ]; }),
                                                                        _: 1
                                                                    }))
                                                                    : _createCommentVNode("", true),
                                                                (searchVisible.value && _ctx.filterable)
                                                                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                        key: 1,
                                                                        ref_key: "searchInClippedTagsRef",
                                                                        ref: searchInClippedTagsRef,
                                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((search).value = $event); }),
                                                                        placeholder: _unref(placeholder),
                                                                        class: "e-select__clipped-tags-input",
                                                                        type: "text",
                                                                        onFocus: onInputFocus
                                                                    }, null, 40, _hoisted_7)), [
                                                                        [_vModelText, search.value]
                                                                    ])
                                                                    : _createCommentVNode("", true)
                                                            ]))
                                                            : (_ctx.multiple && !_ctx.clipTags && selectedOptions.value && selectedOptions.value.length > 0)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptions.value, function (selectedOption) {
                                                                        return (_openBlock(), _createBlock(ETag, {
                                                                            key: selectedOption.value,
                                                                            closable: !_ctx.disabled,
                                                                            class: "m-0.5 shrink truncate",
                                                                            size: "small",
                                                                            onClose: function ($event) { return (onTagClose(selectedOption)); }
                                                                        }, {
                                                                            default: _withCtx(function () { return [
                                                                                _createTextVNode(_toDisplayString(selectedOption.label), 1)
                                                                            ]; }),
                                                                            _: 2
                                                                        }, 1032, ["closable", "onClose"]));
                                                                    }), 128)),
                                                                    (searchVisible.value && _ctx.filterable)
                                                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                            key: 0,
                                                                            ref_key: "searchInTagsRef",
                                                                            ref: searchInTagsRef,
                                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((search).value = $event); }),
                                                                            placeholder: _unref(placeholder),
                                                                            class: "e-select__tags-input",
                                                                            type: "text",
                                                                            onFocus: onInputFocus
                                                                        }, null, 40, _hoisted_9)), [
                                                                            [_vModelText, search.value]
                                                                        ])
                                                                        : _createCommentVNode("", true)
                                                                ]))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                                    (!_ctx.multiple && selectedOptions.value && ((_b = selectedOptions.value._config) === null || _b === void 0 ? void 0 : _b.avatar))
                                                                        ? (_openBlock(), _createBlock(CEmployeeAvatar, {
                                                                            key: 0,
                                                                            employee: selectedOptions.value._config.avatar.employee,
                                                                            src: selectedOptions.value._config.avatar.src,
                                                                            uuid: selectedOptions.value._config.avatar.uuid,
                                                                            class: "select-avatar",
                                                                            onClick: _cache[4] || (_cache[4] = _withModifiers(function () { }, ["stop"]))
                                                                        }, null, 8, ["employee", "src", "uuid"]))
                                                                        : _createCommentVNode("", true),
                                                                    (selectedOptions.value && selectedOptions.value.icon)
                                                                        ? (_openBlock(), _createBlock(EIcon, {
                                                                            key: 1,
                                                                            icon: selectedOptions.value && selectedOptions.value.icon,
                                                                            class: "h-4 w-4 text-primary shrink-0"
                                                                        }, null, 8, ["icon"]))
                                                                        : _createCommentVNode("", true),
                                                                    _createElementVNode("p", null, _toDisplayString((_c = selectedOptions.value) === null || _c === void 0 ? void 0 : _c.label), 1)
                                                                ]))
                                                    ]))
                                            ]))
                                    ], 64))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(EIcon, {
                                        class: _normalizeClass([[
                                                optionsVisible.value && 'rotate-180'
                                            ], "e-select__caret"]),
                                        icon: "caret-down"
                                    }, null, 8, ["class"])
                                ])
                            ], 16)
                        ];
                    }),
                    _: 3
                }, 8, ["visible", "append-to-body", "follow-reference-width", "trigger"]),
                (_ctx.outerTags)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([[
                                _ctx.tagsClass
                            ], "e-select__outer-tags"])
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptions.value, function (option) {
                            return _renderSlot(_ctx.$slots, "outerTag", {
                                option: option,
                                removeOption: onOptionClick
                            }, function () { return [
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createTextVNode(_toDisplayString(option.label) + " ", 1),
                                        (option.group)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, " — " + _toDisplayString(option.group.label), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_component_e_button, {
                                        class: "text-gray-400 hover:text-red-400 shrink-0",
                                        type: "text",
                                        onClick: function ($event) { return (onOptionClick(option)); }
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(EIcon, {
                                                class: "w-4 h-4",
                                                icon: "bucket"
                                            })
                                        ]; }),
                                        _: 2
                                    }, 1032, ["onClick"])
                                ])
                            ]; });
                        }), 256))
                    ], 2))
                    : _createCommentVNode("", true)
            ], 64));
        };
    } }));
